import React from "react";
import { ImEyeMinus,ImEyePlus  } from "react-icons/im";

function CapabilityMapsCard({ map, onEdit, onDelete, onView, onToggleVisibility }) {
  const getStatusBadge = () => {
    if (map.revoked) {
      return <span className="text-xs inline-flex font-medium bg-red-100 text-red-600 rounded-full text-center px-2.5 py-1">Revoked</span>;
    }
    if (map.visible) {
      return <span className="text-xs inline-flex font-medium bg-green-100 text-green-600 rounded-full text-center px-2.5 py-1">Visible</span>;
    }
    return <span className="text-xs inline-flex font-medium bg-slate-100 text-slate-600 rounded-full text-center px-2.5 py-1">Hidden</span>;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <div className="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 bg-white rounded-lg shadow-sm border border-slate-200 hover:shadow-lg transition-shadow duration-200">
      <div className="h-2 rounded-t-lg" style={{ backgroundColor: map.color }}></div>
      
      <div className="p-5">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h3 className="text-lg font-semibold text-slate-800 line-clamp-1" title={map.name}>
              {map.name}
            </h3>
            <p className="text-sm text-slate-500 line-clamp-1" title={map.arabicName}>
              {map.arabicName}
            </p>
          </div>
          {getStatusBadge()}
        </div>
        <div className="mb-3">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
            {map.industry}
          </span>
        </div>
        <p className="text-sm text-slate-600 mb-4 line-clamp-2" title={map.description}>
          {map.description}
        </p>
        <div className="grid grid-cols-2 gap-2 mb-4 text-center">
         
          <div className="bg-slate-50 rounded p-2 w-full">
            <div className="text-xs text-slate-500">Phases</div>
            <div className="text-sm font-semibold text-slate-700">{map.phasesCount}</div>
          </div>
          <div className="bg-slate-50 rounded p-2 w-full">
            <div className="text-xs text-slate-500">Items</div>
            <div className="text-sm font-semibold text-slate-700">{map.itemsCount}</div>
          </div>
        </div>
        <div className="text-xs text-slate-400 mb-4">
          <div>Updated: {formatDate(map.updatedAt)}</div>
        </div>
        <div className="flex justify-between items-center border-t border-slate-100 pt-4">
          <div className="flex space-x-2">
            <button
              onClick={() => onView(map)}
              className="text-slate-400 hover:text-slate-500 transition-colors"
              title="View Details"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </button>
            <button
              onClick={() => onEdit(map)}
              className="text-indigo-400 hover:text-indigo-500 transition-colors"
              title="Edit"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </button>
            <button
              onClick={() => onToggleVisibility(map.id)}
              className={`transition-colors ${
                map.visible ? 'text-green-400 hover:text-green-500' : 'text-slate-400 hover:text-slate-500'
              }`}
              title={map.visible ? "Hide" : "Show"}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {map.visible ? (
                  <ImEyePlus  size={25} />
                ) : (
                  <ImEyeMinus size={25} />
                )}
              </svg>
            </button>
          </div>
          <button
            onClick={() => onDelete(map)}
            className="text-rose-400 hover:text-rose-500 transition-colors"
            title="Delete"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default CapabilityMapsCard;